import { EventDispatcher, inject, service } from "@spawn/core";
import { replaceSymbolEvent } from "@spawn/slot-machine";

@service
export class ReelsetService {
	@inject protected readonly eventDispatcher!: EventDispatcher;

	public replaceVisibleSymbolsOnReelset(reels: string[][]): void {
		for (let x = 0; x < reels.length; x++) {
			const reel = reels[x];
			const visibleSymbols = reel.slice(1, 5); // Remove padding symbols.

			for (const [y, symbolType] of visibleSymbols.entries()) {
				this.eventDispatcher.dispatch(replaceSymbolEvent({ coordinate: { x, y }, symbolType }));
			}
		}
	}
}
